import React, { useState, useEffect, useRef } from 'react'
import UserRoles from '../UserRoles'
import Avatar from 'react-avatar-edit';
import { isImage } from '../../../../Templates/functions'
import Visible from '../../../../../assets/Icons/Eye_Icon.png'
import notVisible from '../../../../../assets/Icons/EyeCrossed_Icon.png'
import DefaultPFP from '../../../../../assets/Icons/deafult_pfp.png'

export const NewUserForm = (props) => {

  const [userName, setUserName] = useState('')
  const [userNameError, setUserNameError] = useState('');
  const [password, setPassword] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [passwordRules, setPasswordRules] = useState('Password must include 1 uppercase, 1 lower case, 1 number, be at least 8 characters long, and contain only letters and numbers (no special characters).')
  const [samePassword, setSamePassword] = useState('')
  const [samePasswordError, setSamePasswordError] = useState('')
  const [inputPasswordType, setInputPasswordType] = useState('password');
  const [inputValidatePasswordType, setInputValidatePasswordType] = useState('password');
  const [isVisiblePW, setIsVisiblePW] = useState(false);
  const [isVisibleValidate, setIsVisibleValidate] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const { currentRole, modifyRole} = props;
  const profileImage = useRef(null);


  const [state, setState] = useState(
    {
      profileImage: null,
      // profileImage: props.profileImage,
      showingUploadForm: false,
      img: "",
      preview: null,
      src: null
    }
  );

  // -------------------------- USER FORM FUNCTIONS -------------------------- //
  useEffect(() => {
    validateForm();
  }, [userName, currentRole, password, samePassword]);

  const createUser = () => {
    if (isFormValid) {

      let user = {
        username: userName,
        password: password,
        // email: email,
        role: currentRole,
        image: "", // replace with actual image if available
        status: "Offline",
        assignments: [], // replace with actual assignments if available
        notifications: [] // replace with actual notifications if available
      }

      props.createUser(user).then(userData => {
        const userID = userData._id

        setTimeout(() => {
          handlePFPSubmit(userID)
        }, 2000)

      }).catch(error => {
        console.error('Error:', error);
      })
      props.closeModal(); // Close the modal
      props.setUserCreated(); // Set the user created flag to true
    } else {
      console.log('Invalid input');
    }
  }



  const update = (field) => {
    return event => {
      if (field === 'userName') {
          setUserName(event.currentTarget.value);
      }else if (field === 'password') {
          setPassword(event.currentTarget.value);
      } else if(field === 'samePassword'){
          setSamePassword(event.currentTarget.value);
      }
      validateForm();
    };
  }

  const validateForm = () => {
    if (userName && 
        validatePassword(password).isValid && 
        currentRole && 
        validateSamePassword(password, samePassword) &&
        !Object.values(props.users).some(user => user.username === userName || user.password === password)) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }

  const validateUserName = (userName) => {
    const regex = /^[a-zA-Z_]+$/;
    return regex.test(userName);
  }

  // const validateEmail = (email) => {
  //     const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //     return regex.test(email);
  // }

  const validatePassword = (password) => {
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasMinLength = password.length >= 8;
    const hasSpecialChar = /[^a-zA-Z0-9]/.test(password);
    
    const errors = [];
    
    if (hasSpecialChar) {
      errors.push("special characters are not allowed");
    }
    if (!hasMinLength) {
      errors.push("must be at least 8 characters long");
    }
    if (!hasUpperCase) {
      errors.push("must include an uppercase letter");
    }
    if (!hasLowerCase) {
      errors.push("must include a lowercase letter");
    }
    if (!hasNumber) {
      errors.push("must include a number");
    }

    return {
      isValid: errors.length === 0,
      errors: errors
    };
  }

  const validateSamePassword = (password, samePassword) => {
    return password === samePassword;
  }

  const togglePasswordVisibility = (event, passwordType, whichButton) => {
    event.preventDefault();
    if(whichButton === 'validate'){
      setIsVisibleValidate(!isVisibleValidate);
    }else{
      setIsVisiblePW(!isVisiblePW);
    }

    if(passwordType === 'password'){
      setInputPasswordType(inputPasswordType === 'password' ? 'text' : 'password');
    }else{
      setInputValidatePasswordType(inputValidatePasswordType === 'password' ? 'text' : 'password');
    }
  }

  const handleBlur = (field) => {
    return event => {
      const value = event.target.value;
      if (field === 'userName') {
        if (!validateUserName(value)) {
          setUserNameError('Invalid user name. Only alphabets and underscores are allowed.');
        } else if (Object.values(props.users).some(user => user.username === value)) {
          setUserNameError('This username is already taken.');
        } else {
          setUserNameError('');
        }
        
      } else if (field === 'password') {
        const validation = validatePassword(value);
        if (!validation.isValid) {
          setPasswordRules('');
          setPasswordError(`Password ${validation.errors.join(', ')}.`);
        } else {
          setPasswordError('');
        }

      } else if(field === 'samePassword'){
        if (value !== password) {
          setSamePasswordError('Passwords do not match');
        } else {
          setSamePasswordError('');
        }
      }
    };
  }

  // -------------------------- PFP FUNCTIONS -------------------------- //
  const onClose = () => {
    setState(prevState => ({ ...prevState, preview: null }));
  }

  const onCrop = (preview) => {
    setState(prevState => ({ ...prevState, img: preview }));
  }

  const onBeforeFileLoad = (elem) => {
    let file = elem.target.files[0];
    if (file) {
      let ext = file.name.split('.').pop();
      if (!isImage(ext)) {
        alert("Only png, tiff, jpg or jpeg images are supported. ");
        elem.target.value = "";
      }
    };
  }


  const setProfilePicture = (image, userID) => {
    props.storeProfileImage(userID, image)
  }
    
  const toDataURL = (url, callback) => {
    var xhr = new XMLHttpRequest();
    
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  const resizeImage = (base64Str, userID) => {
    
    if (state.img === '') {
      return setProfilePicture(DefaultPFP, userID);
    }

    var img = new Image();
    img.src = base64Str;
    img.onload = () => {
      var canvas = document.createElement('canvas');
      var MAX_WIDTH = 400;
      var MAX_HEIGHT = 300;
      var width = img.width;
      var height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      
      return setProfilePicture(canvas.toDataURL(), userID);
    }
  }

  const handlePFPSubmit = (userID) => {
    toDataURL(state.img, (myBase64) => setState(prevState => ({ ...prevState, showingUploadForm: false, profileImage: myBase64, img: "" }), resizeImage(myBase64, userID)));
  }

  const renderErrors = (error) => {
    if (error.includes("E11000")){
      error = "That User Name is already taken"
    }
      return (
        <ul className="flex-columncentered shake-on-error" id="form-errors">
          <li>{error}</li>
        </ul>
      );
  }

  return (
    <form onSubmit={null}>
      <div id='new-work-instruction-form'>
        <div id="option-end" className="flex-column-centered">
            <h3 style={{
              marginBottom: '2%', 
              marginTop: '5px',
              fontWeight: '600', 
              fontSize: '90%' 
            }}>Assign Profile Image</h3>
            <Avatar
              ref={profileImage}
              width={250}
              height={150}
              onCrop={onCrop}
              onClose={onClose}
              onBeforeFileLoad={onBeforeFileLoad}
              src={state.src}
            />
        </div>
        <div id="option-end" className="flex-column-centered">
          <h3 style={{marginBottom: '2%', marginTop: '30px', fontWeight: '600', fontSize: '90%' }}>Create User Name</h3>
          <div className='input-box' style={{ width: "95%" }}>
            <div id="work-instruction-name-container">
              <input id="work-instruction-name"
                type="text"
                value={userName}
                onChange={update('userName')}
                onBlur={handleBlur('userName')}
                placeholder="User Name"
              />
              {userNameError && <div style={{ color: 'red', marginTop: '10px', fontSize: '60%' }}>{userNameError}</div>}
            </div>
          </div>
        </div>
        
        <div id="option-end" className="flex-column-centered">
          <h3 style={{marginBottom: '2%', marginTop: '10px', fontWeight: '600', fontSize: '90%' }}>Set Password</h3>
          <div className='input-box' style={{ width: "95%" }}>
            <div id="work-instruction-name-container" style={{ display: 'flex', alignItems: 'center' }}>
              <input id="work-instruction-name"
                type={inputPasswordType}
                value={password}
                onChange={update('password')}
                onBlur={handleBlur('password')}
                // onChange={this.update('workInstructionTitle')}
                placeholder="Password"
              />
              <button 
                style={{
                  marginLeft: '5px', 
                  backgroundColor: 'transparent', 
                  border: 'none', 
                  cursor: 'pointer'
                }}   
                onClick={(e) => togglePasswordVisibility(e, 'password')}
              >
                <img style={{width: '20px', height: '20px'}} src={isVisiblePW ? Visible : notVisible} alt="visibility-icon" />
              </button>
            </div>
            {passwordError && <div style={{ color: 'red', marginTop: '10px', fontSize: '60%', textAlign: 'center'}}>{passwordError}</div>}
            {passwordRules && <div style={{ color: 'rgb(8, 31, 95)', marginTop: '10px', fontSize: '60%', textAlign: 'center' }}>{passwordRules}</div>}
          </div>
        </div>

        <div id="option-end" className="flex-column-centered">
          <h3 style={{marginBottom: '2%', marginTop: '10px', fontWeight: '600', fontSize: '90%' }}>Validate Password</h3>
          <div className='input-box' style={{ width: "95%" }}>
            <div id="work-instruction-name-container" style={{ display: 'flex', alignItems: 'center' }}>
              <input id="work-instruction-name"
                type={inputValidatePasswordType}
                value={samePassword}
                onChange={update('samePassword')}
                onBlur={handleBlur('samePassword')}
                placeholder="Validate Password"
                style={{ flex: 1 }}
              />
              <button 
                style={{
                  marginLeft: '5px', 
                  backgroundColor: 'transparent', 
                  border: 'none', 
                  cursor: 'pointer'
                }}  
                onClick={(e) => togglePasswordVisibility(e, 'validatePassword', 'validate')}
              >
                <img style={{width: '20px', height: '20px'}} src={isVisibleValidate ? Visible : notVisible} alt="visibility-icon" />
              </button>
            </div>
            {samePasswordError && <div style={{ color: 'red', marginTop: '10px', fontSize: '60%', textAlign: 'center' }}>{samePasswordError}</div>}
          </div>
        </div>

        <div id="option-end" className="flex-column-centered">
          <h3 style={{marginTop: '10px', marginBottom: '5px', fontWeight: '600', fontSize: '90%' }}>Choose Role</h3>
          <div className="flex-column-centered">
            <UserRoles currentRole={currentRole} modifyRole={modifyRole}/>
          </div>
        </div>
        <div className="center-content" style={{ 
          marginTop: '7px',
          marginBottom: '10px'
        }}>
          <button 
            disabled={!isFormValid} 
            onClick={createUser}
            style={{ 
              backgroundColor: isFormValid ? '#5576bd' : 'gray',
              cursor: isFormValid ? 'pointer' : 'not-allowed'
            }}
            className={`button clickable`}
          >
            Create
          </button>
        </div>
      </div>
    </form>
  )
}
